export class ProductUploadModel {
    file: File;
    entityId: number;
    entityTypeId: number;
}
